<script>
import AppBanner from '@/components/shared/AppBanner';
import HomeShowcase from '../components/shared/HomeShowcase.vue';
import projects from '../data/projects';
import robots from '../data/robots';

export default {
	name: 'Home',
	components: {
		AppBanner,
		HomeShowcase,
	},
	data() {
		return {
			projects,
			robots,
		};
	},
};
</script>

<template>
	<div class="container mx-auto">
		<!-- Banner -->
		<AppBanner class="mb-5 sm:mb-8" />

		<!-- 视觉和大模型项目（一行三个 + 更多按钮） -->
		<HomeShowcase
			title="视觉和大模型项目"
			:items="projects"
			base-path="/projects"
			more-link="/projects"
			more-text="查看更多项目"
		/>

		<!-- 机器人项目（一行三个 + 更多按钮） -->
		<HomeShowcase
			title="机器人项目"
			:items="robots"
			base-path="/robots"
			more-link="/robots"
			more-text="查看更多机器人"
		/>
	</div>
</template>

<style scoped></style>
